import { Helmet } from "react-helmet";
import { Container } from "reactstrap";

import { PageTitles } from "../../../constants";

import AddContent from "./AddContent";

export default function AddContentDetails() {
    return (
        <div className="page-content">
            <Helmet>
                <title>{PageTitles.ADD_CONTENT_LIBRARY_ITEM}</title>
            </Helmet>
            <Container fluid className="customer-details">
                <AddContent />
            </Container>
        </div>
    );
}
